import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { logBrowserInfo, logNavigation } from '@Utils/analytics';
import { registerAnalyticsFlushOnPageHide } from '@Utils/analytics/proceedEvents';

/**
 * Emits the ambient events every investigation needs: which browser, and which page the user
 * was on. Mount once, inside the router.
 */
export const useAnalytics = () => {
  const location = useLocation();
  const previousPathname = useRef('');

  useEffect(() => {
    logBrowserInfo();

    return registerAnalyticsFlushOnPageHide();
  }, []);

  useEffect(() => {
    if (previousPathname.current === location.pathname) {
      return;
    }

    logNavigation(location.pathname, previousPathname.current, location.search);
    previousPathname.current = location.pathname;
  }, [location.pathname, location.search]);
};
